/**
 * 学生表单的共享业务逻辑
 * @param {Object} initialData - 初始数据（编辑模式使用）
 * @returns {Object} 表单状态和方法
 */
export const useStudentForm = (initialData = {}) => {
  // 性别选项
  const genderOptions = ["男", "女"];
  
  // 状态选项
  const statusOptions = ["在学", "潜在", "已结束"];

  // 获取当前年份
  const getCurrentYear = () => new Date().getFullYear();

  // 生成年份范围（最近20年）
  const getYearRange = () => {
    const currentYear = getCurrentYear();
    return Array.from({ length: 20 }, (_, i) => currentYear - i);
  };

  // 生成月份选项（1-12）
  const getMonthOptions = () => {
    return Array.from({ length: 12 }, (_, i) => i + 1);
  };

  return {
    genderOptions,
    statusOptions,
    getCurrentYear,
    getYearRange,
    getMonthOptions,
  };
};
